import { cn } from '../lib/cn';
import { LogoMark } from './LogoMark';

/**
 * Maclaren sign: the mark plus a tight lowercase wordmark. `intro`
 * draws the mark and lets the letters rise one by one (login
 * showcase); otherwise it is static.
 */
export function Wordmark({ intro = false, className }: { intro?: boolean; className?: string }) {
  return (
    <span className={cn('mc-wordmark inline-flex items-center gap-[0.32em]', className)}>
      <span className="sr-only">Maclaren</span>
      <LogoMark className="h-[0.86em] w-auto" motion={intro ? 'draw' : undefined} />
      <span aria-hidden="true" className="-translate-y-[0.04em]">
        {intro
          ? [...'maclaren'].map((ch, i) => (
              <span
                // biome-ignore lint/suspicious/noArrayIndexKey: fixed string
                key={i}
                className="mc-letter"
                style={{ animationDelay: `${450 + i * 40}ms` }}
              >
                {ch}
              </span>
            ))
          : 'maclaren'}
      </span>
    </span>
  );
}
